import { render, staticRenderFns } from "./CoCoappBadge.vue?vue&type=template&id=8c18586c&scoped=true&"
import script from "./CoCoappBadge.vue?vue&type=script&lang=ts&"
export * from "./CoCoappBadge.vue?vue&type=script&lang=ts&"
import style0 from "./CoCoappBadge.vue?vue&type=style&index=0&id=8c18586c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c18586c",
  null
  
)

export default component.exports